import React, { useEffect } from "react"
import PropTypes from "prop-types"
import ResourceSelector from "./ResourceSelector";

const UnitSelectorForConfigurableEntity = (props) => {

    const getQueryParams = () => {
        let queryParams = {};

        if (props.forUser) {
            queryParams['for_user'] = props.forUser
        }

        if (props.forEntityType && props.forEntityId) {
            queryParams['entity_type'] = props.forEntityType;
            queryParams['entity_id'] = props.forEntityId;
        }

        return queryParams;
    }

    return (
        <ResourceSelector
            {...props}
            placeholder="Please Select"
            listLabel="Start typing to filter the list..."
            type={'units-for-configurable-entity'}
            noOptionsMessage={() => "Type to select from units"}
            queryParams={getQueryParams()}
            isClearable
            autoSelectSingleOption
        />
    )
}

UnitSelectorForConfigurableEntity.propTypes = {
    name: PropTypes.string,
    multi: PropTypes.bool,
    forUser: PropTypes.string,
    forCategory: PropTypes.string,
    forAmenity: PropTypes.string,
    autoSelectFirstOption: PropTypes.bool,
}

UnitSelectorForConfigurableEntity.defaultProps = {
    name: 'units',
    multi: false,
    value: null,
    forUser: null,
    forEntityType: null,
    forEntityId: null,
    autoSelectFirstOption: false,
}

export default UnitSelectorForConfigurableEntity;
